export {default as ArrowsPlugin } from './arrows-plugin';
export {default as AutoPlugin } from './auto-plugin';
export {default as DNLinksPlugin } from './dnlinks-plugin';
export {default as DotsPlugin } from './dots-plugin';
export {default as HeightPlugin } from './height-plugin';
export {default as ResizerPlugin } from './resizer-plugin';
export {default as ResponsivePlugin } from './responsive-plugin';
export {default as TouchPlugin } from './touch-plugin';
export {default as TransitionPlugin} from './transition-plugin';
export {default as VideoPlugin} from './video-plugin';
export {default as VisibilityPlugin} from './visibility-plugin';


// WEBPACK FOOTER //
// ./scripts/components/carousels/plugins/index.js